import React, { useEffect, useRef, useState, useContext } from "react";
import styles from "./ModalUploadFileV2.module.css";
import Input from "../input/Input";
import Button from "../button/Button";
import { HashLoader } from "react-spinners";

import { CurrentUserContext } from "../../../App";

function ModalUploadFileV2({ show, onSubmit, onClose, title, placeholder }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const inputFileRef = useRef(null);
  const [file, setFile] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [disabledButton, setDisabledButton] = useState(false);

  useEffect(() => {
    setFile(null);
    setInputValue("");
    setDisabledButton(false);
  }, [show]);

  const inputFileChange = (event) => {
    let fileObj = event.target.files[0];
    // console.log(fileObj)
    setFile(fileObj);
  };
  const submitButton = () => {
    if (!file) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกไฟล์" });
      return;
    }

    onSubmit({
      file: file,
      inputValue: inputValue,
    });
  };
  return (
    <>
      {show ? (
        <div className={styles.overlay}>
          <div className={styles.modalController}>
            <div className={styles.closeButton}>
              <img
                onClick={() => {
                  onClose();
                }}
                src={require("../../../asset/icon/close-icon.svg").default}
              ></img>
            </div>
            <div className={styles.contentModal}>
              <div className={styles.title}>{title || "-"}</div>
              <div className={styles.line}></div>

              <div className={styles.container}>
                <Input
                  value={inputValue}
                  setValue={setInputValue}
                  placeholder={placeholder || "ระบุ"}
                />
                <input
                  accept=".pdf"
                  type={"file"}
                  ref={inputFileRef}
                  onChange={(e) => {
                    inputFileChange(e);
                  }}
                  style={{ display: "none" }}
                ></input>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={() => {
                      inputFileRef.current.click();
                    }}
                    style={{ gridGap: 10 }}
                  >
                    <div>อัปโหลดไฟล์</div>
                    <img
                      src={
                        require("../../../asset/icon/upload-icon.svg").default
                      }
                    ></img>
                  </Button>
                </div>

                <div className={styles.fileName}>{file ? file.name : "-"}</div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    disabled={disabledButton}
                    onClick={() => {
                      // setDisabledButton(true)
                      submitButton();
                    }}
                  >
                    บันทึก
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default ModalUploadFileV2;
